import { appendProtocol } from '@/postContentElement/components/utils/link';
import { usePostContentContext } from '@/postContentElement/context';
import { evaluateAndAppendUTMParams } from '@/utils/evaluateAndAppendUTMParams';

interface Props {
  anchorId?: string;
  embedUrl?: string;
}

const Youtube = ({ anchorId, embedUrl }: Props) => {
  const { utmParams } = usePostContentContext();
  const embedUrlWithUTMParams = evaluateAndAppendUTMParams(appendProtocol(embedUrl), utmParams);

  return (
    <div className="p-4">
      <div className="mx-auto" style={{ maxWidth: '520px' }} id={anchorId}>
        <div className="relative w-full h-0" style={{ paddingBottom: '56.25%' }}>
          <iframe
            className="absolute top-0 left-0"
            width="100%"
            height="100%"
            src={embedUrlWithUTMParams}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            title="Youtube embed"
          />
          {/* allowfullscreen */}
        </div>
      </div>
    </div>
  );
};

export { Youtube };
